(function () {
  const SELECTOR = '.text-block .gradiant_text';
  const REVEALED = 'is-revealed';

  function init(scope) {
    const targets = (scope || document).querySelectorAll(SELECTOR);
    if (!targets.length) return;

    // No observer support → just show it filled
    if (!('IntersectionObserver' in window)) {
      targets.forEach((el) => el.classList.add(REVEALED));
      return;
    }

    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add(REVEALED);
          obs.unobserve(entry.target); // fire once, never again
        }
      });
    }, { threshold: 0.3 }); // ~30% of the text visible

    targets.forEach((el) => {
      if (!el.classList.contains(REVEALED)) observer.observe(el);
    });
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  // Re-bind when the section reloads in the theme editor
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();